import { can, type Cap } from "@savvy/shared";

import { useAuth } from "../auth/store";

/**
 * Capability gating.
 *
 * `Caps` comes from @savvy/shared, which tools/capgen writes from the same
 * manifests the Go services read. There are NO hand-written capability strings
 * in app code — a hand-maintained mirror is precisely what drifted across three
 * repos in the system this replaces, and an eslint rule bans the literals.
 *
 * The UI only ever HIDES. The server is the authority: a hidden control reached
 * by other means still gets a 403, which was verified live during Phase 3.
 */
export function useCan(cap: Cap | string): boolean {
  return useAuth((s) => can(s.effective, cap));
}

/** All effective capabilities, for a component gating several things at once. */
export function useCaps(): Set<string> {
  return useAuth((s) => s.effective);
}
